<template>
    <div>
        <filter-string :current="filterString"
                       vehicle-type="lcv"
        >
        </filter-string>

        <div class="col-sm-12">
            <div class="Panel">
                <div class="Panel__heading Panel__heading--plain">
                    Total LCV Registrations
                    <graph-exporter :title="reports.totalSalesGraph.title"
                                    v-if="reports.totalSalesGraph"
                    ></graph-exporter>
                </div>
                <div class="Panel__body">
                    <line-chart :labels="reports.totalSalesGraph.labels"
                                :datasets="reports.totalSalesGraph.datasets"
                                :title="reports.totalSalesGraph.title"
                                v-if="reports.totalSalesGraph"
                    ></line-chart>
                </div>
                <div class="Panel__overlay" v-show="sources.totalSalesGraph.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel">
                <div class="Panel__heading Panel__heading--plain">
                    Total LCV Registrations
                    <exporter vehicle-type="lcv"
                              :title="reports.totalSalesTable.title"
                              :column-formats="reports.totalSalesTable.columnFormats"
                              :columns="reports.totalSalesTable.columns"
                              :rows="reports.totalSalesTable.rows"
                              v-if="reports.totalSalesTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.totalSalesTable.columns"
                                      :columnFormats="reports.totalSalesTable.columnFormats"
                                      :rows="reports.totalSalesTable.rows"
                                      v-if="reports.totalSalesTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.totalSalesTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-make">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By Make
                    <exporter vehicle-type="lcv"
                              :title="reports.salesByMakeTable.title"
                              :column-formats="reports.salesByMakeTable.columnFormats"
                              :columns="reports.salesByMakeTable.columns"
                              :rows="reports.salesByMakeTable.rows"
                              v-if="reports.salesByMakeTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByMakeTable.columns"
                                      :columnFormats="reports.salesByMakeTable.columnFormats"
                                      :rows="reports.salesByMakeTable.rows"
                                      v-if="reports.salesByMakeTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByMakeTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-model">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercials Vehicles By Model
                    <exporter vehicle-type="lcv"
                              :title="reports.salesByModelTable.title"
                              :column-formats="reports.salesByModelTable.columnFormats"
                              :columns="reports.salesByModelTable.columns"
                              :rows="reports.salesByModelTable.rows"
                              v-if="reports.salesByModelTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByModelTable.columns"
                                      :columnFormats="reports.salesByModelTable.columnFormats"
                                      :rows="reports.salesByModelTable.rows"
                                      v-if="reports.salesByModelTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByModelTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12" v-if="canViewSalesTypes">
            <div class="Panel" id="sales-by-sales-type">
                <div class="Panel__heading Panel__heading--plain">
                    Passenger Cars By Sales Type
                    <exporter vehicle-type="passenger"
                              :title="reports.salesBySalesTypeTable.title"
                              :column-formats="reports.salesBySalesTypeTable.columnFormats"
                              :columns="reports.salesBySalesTypeTable.columns"
                              :rows="reports.salesBySalesTypeTable.rows"
                              v-if="reports.salesBySalesTypeTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesBySalesTypeTable.columns"
                                      :columnFormats="reports.salesBySalesTypeTable.columnFormats"
                                      :rows="reports.salesBySalesTypeTable.rows"
                                      v-if="reports.salesBySalesTypeTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesBySalesTypeTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-body-type">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By Body Type
                    <exporter vehicle-type="passenger"
                              :title="reports.salesByBodyTypeTable.title"
                              :column-formats="reports.salesByBodyTypeTable.columnFormats"
                              :columns="reports.salesByBodyTypeTable.columns"
                              :rows="reports.salesByBodyTypeTable.rows"
                              v-if="reports.salesByBodyTypeTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByBodyTypeTable.columns"
                                      :columnFormats="reports.salesByBodyTypeTable.columnFormats"
                                      :rows="reports.salesByBodyTypeTable.rows"
                                      v-if="reports.salesByBodyTypeTable"
                    >
                    </responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByBodyTypeTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-engine-type">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By Engine Type
                    <exporter vehicle-type="passenger"
                              :title="reports.salesByEngineTypeTable.title"
                              :column-formats="reports.salesByEngineTypeTable.columnFormats"
                              :columns="reports.salesByEngineTypeTable.columns"
                              :rows="reports.salesByEngineTypeTable.rows"
                              v-if="reports.salesByEngineTypeTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByEngineTypeTable.columns"
                                      :columnFormats="reports.salesByEngineTypeTable.columnFormats"
                                      :rows="reports.salesByEngineTypeTable.rows"
                                      v-if="reports.salesByEngineTypeTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByEngineTypeTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-transmission">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By Transmission
                    <exporter vehicle-type="passenger"
                              :title="reports.salesByTransmissionTable.title"
                              :column-formats="reports.salesByTransmissionTable.columnFormats"
                              :columns="reports.salesByTransmissionTable.columns"
                              :rows="reports.salesByTransmissionTable.rows"
                              v-if="reports.salesByTransmissionTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByTransmissionTable.columns"
                                      :columnFormats="reports.salesByTransmissionTable.columnFormats"
                                      :rows="reports.salesByTransmissionTable.rows"
                                      v-if="reports.salesByTransmissionTable"
                    >
                    </responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByTransmissionTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-weight">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By Gross Weight
                    <exporter vehicle-type="lcv"
                              :title="reports.salesByWeightTable.title"
                              :column-formats="reports.salesByWeightTable.columnFormats"
                              :columns="reports.salesByWeightTable.columns"
                              :rows="reports.salesByWeightTable.rows"
                              v-if="reports.salesByWeightTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByWeightTable.columns"
                                      :columnFormats="reports.salesByWeightTable.columnFormats"
                                      :rows="reports.salesByWeightTable.rows"
                                      :limit-rows="false"
                                      v-if="reports.salesByWeightTable"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByWeightTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12">
            <div class="Panel" id="sales-by-county">
                <div class="Panel__heading Panel__heading--plain">
                    Light Commercial Vehicles By County
                    <exporter vehicle-type="lcv"
                              :title="reports.salesByCountyTable.title"
                              :column-formats="reports.salesByCountyTable.columnFormats"
                              :columns="reports.salesByCountyTable.columns"
                              :rows="reports.salesByCountyTable.rows"
                              v-if="reports.salesByCountyTable"
                    ></exporter>
                </div>
                <div class="Panel__body">
                    <responsive-table :columns="reports.salesByCountyTable.columns"
                                      :columnFormats="reports.salesByCountyTable.columnFormats"
                                      :name="reports.salesByCountyTable.title"
                                      :rows="reports.salesByCountyTable.rows"
                                      :limit-rows="false"
                                      :sortBy="0"
                                      v-if="reports.salesByCountyTable"
                                      :show-expanders="showExpanders"
                    ></responsive-table>
                </div>
                <div class="Panel__overlay" v-show="sources.salesByCountyTable.loading">
                    <div class="Panel__overlay-text">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                    </div>
                </div>
            </div>
        </div>

        <div v-show="showUsedOnlyGraphs">
            <div class="col-sm-12">
                <div class="Panel" id="sales-by-age-profile">
                    <div class="Panel__heading Panel__heading--plain">
                        Light Commercials Vehicles By Age Profile
                        <exporter vehicle-type="passenger"
                                  :title="reports.salesByAgeProfile.title"
                                  :column-formats="reports.salesByAgeProfile.columnFormats"
                                  :columns="reports.salesByAgeProfile.columns"
                                  :rows="reports.salesByAgeProfile.rows"
                                  v-if="reports.salesByAgeProfile"
                        ></exporter>
                    </div>
                    <div class="Panel__body">
                        <responsive-table :columns="reports.salesByAgeProfile.columns"
                                          :columnFormats="reports.salesByAgeProfile.columnFormats"
                                          :rows="reports.salesByAgeProfile.rows"
                                          :limit-rows="false"
                                          v-if="reports.salesByAgeProfile"
                        ></responsive-table>
                    </div>
                    <div class="Panel__overlay" v-show="sources.salesByAgeProfile.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="showUsedOnlyGraphs || showNewImportGraphs">
            <div class="col-sm-12">
                <div class="Panel" id="sales-by-origin">
                    <div class="Panel__heading Panel__heading--plain">
                        Light Commercials Vehicles By Origin
                        <exporter vehicle-type="passenger"
                                  :title="reports.salesByOrigin.title"
                                  :column-formats="reports.salesByOrigin.columnFormats"
                                  :columns="reports.salesByOrigin.columns"
                                  :rows="reports.salesByOrigin.rows"
                                  v-if="reports.salesByOrigin"
                        ></exporter>
                    </div>
                    <div class="Panel__body">
                        <responsive-table :columns="reports.salesByOrigin.columns"
                                          :columnFormats="reports.salesByOrigin.columnFormats"
                                          :rows="reports.salesByOrigin.rows"
                                          v-if="reports.salesByOrigin"
                        ></responsive-table>
                    </div>
                    <div class="Panel__overlay" v-show="sources.salesByOrigin.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dashboard from '../../../../mixins/dashboard';

    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken,
                lineChart: '',
                lineChart2: '',
                lineChart3: '',

                reports: {
                    totalSalesGraph: null,
                    totalSalesTable: null,
                    salesByMakeTable: null,
                    salesByModelTable: null,
                    salesByCountyTable: null,
                    salesByWeightTable: null,
                    salesByAgeProfile: null,
                    salesByOrigin: null,
                    salesByBodyTypeTable: null,
                    salesByEngineTypeTable: null,
                    salesBySalesTypeTable: null,
                    salesByTransmissionTable: null
                },

                sources: {
                    totalSalesGraph: { report: 'totalSalesGraph', 'url': '/motorstats/light-commercial-vehicles/total-sales/graph' },
                    totalSalesTable: { report: 'totalSalesTable', 'url': '/motorstats/light-commercial-vehicles/total-sales/table' },
                    salesByMakeTable: { report: 'salesByMakeTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-make/table' },
                    salesByModelTable: { report: 'salesByModelTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-model/table' },
                    salesByCountyTable: { report: 'salesByCountyTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-county/table' },
                    salesByWeightTable: { report: 'salesByWeightTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-weight/table' },
                    salesByBodyTypeTable: { report: 'salesByBodyTypeTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-body-type/table' },
                    salesByEngineTypeTable: { report: 'salesByEngineTypeTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-engine-type/table' },
                    salesBySalesTypeTable: { report: 'salesBySalesTypeTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-sales-type/table' },
                    salesByAgeProfile: { report: 'salesByAgeProfile', 'url': '/motorstats/light-commercial-vehicles/sales-by-age-profile/table' },
                    salesByOrigin: { report: 'salesByOrigin', 'url': '/motorstats/light-commercial-vehicles/sales-by-origin/table' },
                    salesByTransmissionTable: { report: 'salesByTransmissionTable', 'url': '/motorstats/light-commercial-vehicles/sales-by-transmission/table' },
                },
            }
        },

        mixins: [dashboard],

        props: {
            filterString: {
                required: true,
                type: String
            },

            showExpanders: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>